


































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { LoginUser } from '@/types/user'
import { MediaComponentProps } from '@/components/common/videoCallRoom/VideoCallRoomContainer.vue'

export const enum ScreenMode {
  SINGLE,
  LISTING
}

@Component({
  components: {
    VideoCallMainScreenContainer: () =>
      import(
        '@/components/common/videoCallRoom/VideoCallMainScreenContainer.vue'
      ),
    VideoCallMainScreen: () =>
      import('@/components/common/videoCallRoom/VideoCallMainScreen.vue'),
    VideoCallSubScreenGridList: () =>
      import('@/components/common/videoCallRoom/VideoCallSubScreenGridList.vue')
  }
})
export default class PatientVideoCallRoom extends Vue {
  @Prop(Object) user!: LoginUser
  @Prop(Array) participants!: Array<MediaComponentProps>

  @Prop({ type: Object, default: null })
  mainScreenParticipant!: MediaComponentProps | null

  @Prop({ default: '' }) occupationCode!: string
  @Prop({ default: '' }) occupationShortName!: string

  readonly SCREEN_MODE_SINGLE = ScreenMode.SINGLE
  readonly SCREEN_MODE_LISTING = ScreenMode.LISTING

  $store!: ExStore
  screenMode = this.SCREEN_MODE_SINGLE

  get mainScreenOn() {
    return this.mainScreenParticipant != null
  }

  async handleHangUp() {
    this.$emit('hangup')
  }

  handleListSubScreen() {
    this.screenMode = this.SCREEN_MODE_LISTING
    this.$emit('changeScreenMode', this.screenMode)
  }

  handleChangeMainScreen(id: number) {
    this.$store.commit('videoCallRoom/setMainScreenParticipant', { id })
    this.screenMode = this.SCREEN_MODE_SINGLE
    this.$emit('changeScreenMode', this.screenMode)
  }
}
